export default "__VITE_ASSET__979d032f__"